import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {Button} from '@components/common/base/buttons'

interface Props<P extends {chatId: string}> {
  readonly chats: ReadonlyArray<P>
  readonly chatView: React.ComponentType<P>
  readonly itemClick?: (chatId: string) => void
}

interface State {
  maxLength: number
}

export class ChatList<P extends {chatId: string}> extends React.Component<
  Props<P>,
  State
> {
  public override state = {
    maxLength: 50
  }

  public override render(): React.ReactNode {
    const {chats} = this.props
    const {maxLength} = this.state

    const total = chats.length
    const list = chats.slice(0, maxLength).map(this.renderItem)
    const bem = Util.bemFrom('chat-list')
    const more = () => {
      this.setState({maxLength: maxLength + 50})
    }

    return (
      <ul className={bem()}>
        {list}
        {total > maxLength && (
          <>
            <div className={bem('more-num')}>
              {Lang.msg.common.moreChats}: {total - maxLength}
            </div>
            <Button size="small" className="mt-8 mb-16 mx-auto" onClick={more}>
              {Lang.msg.showMore2}
            </Button>
          </>
        )}
      </ul>
    )
  }

  private renderItem = (item: P, index: number) => {
    const ChatView = this.props.chatView
    const onClick = () => this.props.itemClick?.(item.chatId)
    const bem = Util.bemFrom('chat-list')
    return (
      <li
        className={bem('item')}
        onClick={onClick}
        key={item.chatId + '-' + index}
      >
        <ChatView {...item} />
      </li>
    )
  }
}
